import { Component, ElementRef, ViewChild, input, output, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TagColorService } from '../../../services/tag.service';

@Component({
    selector: 'em-tag-input',
    templateUrl: './tag-input.component.html',
    styleUrls: ['./tag-input.component.scss'],
    standalone: false
})
export class TagInputComponent {
  readonly tagColorService = inject(TagColorService);


  readonly tags = input<string[]>([]);

  open: boolean = false;
  needle: string | undefined;

  readonly add = output<string>();
  
  @ViewChild('inputElement') private input!: ElementRef;
  @ViewChild('addForm')
  private addForm!: NgForm;

  onToggle(): void {
    this.open = !this.open;

    if (this.open) {
      setTimeout(() => this.input.nativeElement.focus(), 100);
    }
  }

  public onCreate(): void {
    if (this.addForm.valid && this.needle?.trim()) {
      this.onSubmit(this.needle.trim());
    }
  }

  onSubmit(value: string): void {
    this.add.emit(value);
    this.onCloseDialog();
  }

  onCloseDialog(): void {
    this.open = false;
    this.addForm.resetForm();
  }

}
